export enum DateRangeFilter {
  ALL = 'All Dates',
  TODAY = 'Today',
  YESTERDAY = 'Yesterday',
  LAST_WEEK = 'Last Week',
  LAST_MONTH = 'Last Month',
  AFTER = 'After',
  BEFORE = 'Before',

  THIS_MONTH = 'This Month',
  LAST_7_DAYS = 'Last 7 Days',
  LAST_30_DAYS = 'Last 30 Days',
  LAST_60_DAYS = 'Last 60 Days',
  LAST_90_DAYS = 'Last 90 Days',
  LAST_6_MONTHS = 'Last 6 Months',
  LAST_12_MONTHS = 'Last 12 Months',
  BETWEEN = 'Date to Date (Between)',
}

export const DATE_RANGE_FILTER_OPTIONS = [
  DateRangeFilter.ALL,
  DateRangeFilter.TODAY,
  DateRangeFilter.YESTERDAY,
  DateRangeFilter.LAST_WEEK,
  DateRangeFilter.LAST_MONTH,
  DateRangeFilter.THIS_MONTH,
  DateRangeFilter.BETWEEN,
  DateRangeFilter.AFTER,
  DateRangeFilter.BEFORE,
];

/**
 * New default options as requested
 */
export const NEW_DATE_RANGE_FILTER_OPTIONS = [
  DateRangeFilter.LAST_7_DAYS,
  DateRangeFilter.LAST_30_DAYS,
  DateRangeFilter.LAST_60_DAYS,
  DateRangeFilter.LAST_90_DAYS,
  DateRangeFilter.LAST_6_MONTHS,
  DateRangeFilter.LAST_12_MONTHS,
  DateRangeFilter.THIS_MONTH,
  DateRangeFilter.LAST_MONTH,
  DateRangeFilter.BETWEEN,
];

export const ANALYTICS_DATE_FILTER_OPTIONS = [
  DateRangeFilter.TODAY,
  DateRangeFilter.LAST_7_DAYS,
  DateRangeFilter.LAST_WEEK,
  DateRangeFilter.LAST_30_DAYS,
  DateRangeFilter.LAST_MONTH,
  DateRangeFilter.BETWEEN,
];

/**
 * Maps a `ReportPeriod` name from the API's `appliedPeriod` echo onto the dropdown option that
 * represents the same window. Used when a report auto-widens its date range server-side and the
 * filter has to be re-synced to match what is actually on screen.
 */
export const REPORT_PERIOD_TO_DATE_RANGE_FILTER: Record<
  string,
  DateRangeFilter
> = {
  LAST_30_DAYS: DateRangeFilter.LAST_30_DAYS,
  LAST_60_DAYS: DateRangeFilter.LAST_60_DAYS,
  LAST_90_DAYS: DateRangeFilter.LAST_90_DAYS,
  LAST_6_MONTHS: DateRangeFilter.LAST_6_MONTHS,
  LAST_12_MONTHS: DateRangeFilter.LAST_12_MONTHS,
};
